export const PLAY_STORE_URL = "https://play.google.com/store/apps/details?id=com.bongdate.bongDate";

// Heavy media is served from Cloudflare R2 (free egress) instead of Vercel
export const ASSETS_URL =
  "https://pub-50d3bf9f0e964cdabeae6ecad508e9df.r2.dev/assets/seconddate-website-assets/assets";